import { useNavigate } from 'react-router-dom';

const TermosDeUso = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 py-12">
            <div className="container mx-auto px-4 max-w-4xl">
                <button
                    onClick={() => navigate(-1)}
                    className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-8"
                >
                    <i className="fas fa-arrow-left mr-2"></i>
                    Voltar
                </button>

                <div className="bg-white rounded-lg shadow-lg p-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Termos de Uso</h1>
                    <p className="text-gray-600 mb-4">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

                    <div className="prose max-w-none">
                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Aceitação dos Termos</h2>
                            <p className="text-gray-700 mb-4">
                                Ao utilizar nossos serviços de transformação de site em aplicativo, você concorda com estes Termos de Uso e com nossa Política de Privacidade.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Serviços Oferecidos</h2>
                            <h3 className="text-xl font-medium text-gray-800 mb-3">O que pode ser realizado:</h3>
                            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                                <li>Conversão de sites responsivos em aplicativos nativos</li>
                                <li>Publicação nas lojas de aplicativos (Google Play e App Store)</li>
                                <li>Implementação de funcionalidades nativas (notificações push, câmera, GPS)</li>
                                <li>Otimização de performance para dispositivos móveis</li>
                                <li>Manutenção e atualizações periódicas</li>
                            </ul>

                            <h3 className="text-xl font-medium text-gray-800 mb-3">Obrigações do cliente:</h3>
                            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                                <li>Fornecer conteúdo legítimo e autorizado</li>
                                <li>Manter as credenciais de publicação atualizadas</li>
                                <li>Respeitar as diretrizes das lojas de aplicativos</li>
                                <li>Arcar com as taxas de publicação quando aplicável</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Limitações e Restrições</h2>
                            <h3 className="text-xl font-medium text-gray-800 mb-3">O que não pode ser feito:</h3>
                            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                                <li>Conteúdo ilegal ou infringindo direitos autorais</li>
                                <li>Aplicativos que promovam ódio, violência ou discriminação</li>
                                <li>Spam ou conteúdo enganoso</li>
                                <li>Phishing ou coleta maliciosa de dados</li>
                                <li>Violação de propriedade intelectual de terceiros</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Propriedade Intelectual</h2>
                            <p className="text-gray-700 mb-4">
                                O cliente mantém todos os direitos sobre seu conteúdo. A CriaApp detém os direitos sobre a tecnologia de conversão e adaptação.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Fidelidade, Cancelamento e Multa Rescisória</h2>
                            <p className="text-gray-700 mb-4">
                                Os serviços são regidos por período de fidelidade contratual mínima de 12 (doze) meses, justificada pelo investimento inicial da CriaApp na compilação, adaptação de código e homologação nas lojas de aplicativos. O cancelamento antecipado antes do cumprimento integral deste período sujeita o contratante ao pagamento de multa rescisória de 30% (trinta por cento) sobre o saldo remanescente das parcelas.
                            </p>
                            <p className="text-gray-700 mb-4">
                                É expressamente vedada a abertura de contestações injustificadas de pagamento (*chargebacks*) após a entrega dos serviços e compilação do app. Para conferir todas as cláusulas e condições jurídicas detalhadas, consulte o nosso <button onClick={() => navigate('/contrato')} className="text-blue-600 font-bold underline hover:text-blue-800">Contrato Completo de Prestação de Serviços</button>.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Contato</h2>
                            <p className="text-gray-700">
                                Dúvidas sobre estes termos podem ser esclarecidas através do nosso WhatsApp ou email de suporte.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermosDeUso;